<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  text: {
    type: String,
    default: '',
  },
  backgroundColor: {
    type: String,
    default: '',
  },
});

const isExpanded = ref(false);

const toggle = () => {
  isExpanded.value = !isExpanded.value;
};

watch(
  () => props.text,
  () => {
    isExpanded.value = false;
  },
);
</script>

<template>
  <section
    v-if="text"
    class="section"
    :class="[
      backgroundColor ? `bg-${backgroundColor}` : '',
      backgroundColor === 'black' ? 'white' : 'black',
      'section--top-xl',
      'section--bottom-xl',
    ]"
  >
    <div class="container">
      <div class="car__text label">
        <div
          class="car__text__content"
          :class="{ 'car__text__content--collapsed': !isExpanded }"
          :style="{ '--max-lines': 3 }"
          v-html="text"
        />
        <div v-if="text" class="car__text-show">
          <Button
            text
            size="small"
            class="car__text-show-button link-normal js-button-car-text"
            @click="toggle"
          >
            <span>
              {{
                isExpanded ? $t('filters.text_hide') : $t('filters.text_show')
              }}
            </span>
            <CIcon
              name="direction-small-black"
              width="16"
              height="16"
              :class="[
                isExpanded
                  ? 'catalog__text-show-button-arrow catalog__text-show-button-arrow--up'
                  : 'catalog__text-show-button-arrow',
              ]"
            />
          </Button>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.car__text {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 16px;
  text-align: left;
  @include media-breakpoint-up(md) {
    padding: 0 48px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(padding-left, 48);
    @include responsive-spacing(padding-right, 48);
  }
  &:deep(img) {
    vertical-align: middle;
    height: auto !important;
    max-width: 100%;
  }
  &:deep(h2) {
    @include h4;
  }
  &:deep(h3) {
    @include h5;
  }
  &:deep(h4) {
    @include h6;
  }
  &:deep(h5) {
    @include body-1-bold;
  }
  &:deep(h6) {
    @include body-2-bold;
  }
  &-show {
    margin-left: auto;
    &-button {
      align-items: center;
      display: grid;
      justify-content: start;
      gap: 8px;
      grid-template-columns: auto 16px;
      padding: 0 12px !important;
      @include media-breakpoint-up(md) {
        padding: 0 4px !important;
      }
      @include media-breakpoint-up(xl) {
        grid-template-columns: auto px-to-vw(16);
        @include responsive-spacing(gap, 8);
        @include responsive-spacing(padding-left, 4, true);
        @include responsive-spacing(padding-right, 4, true);
      }
      &-arrow {
        height: auto;
        transform: rotate(90deg);
        width: 100%;
        &--up {
          transform: rotate(-90deg);
        }
      }
    }
  }
  &__content {
    overflow: hidden;
    transition: max-height 0.3s ease;
    line-height: 1.5;

    &--collapsed {
      display: -webkit-box;
      -webkit-line-clamp: var(--max-lines);
      -webkit-box-orient: vertical;
    }
    &:deep(p) {
      margin-bottom: 8px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
